export default __webpack_public_path__ + "static/media/hmd_grid_s.f1bbf009.jpg";